import ClickData from "./clickdata";
import DisplayChannel from "./channeldisplay";
import {ParsedUrlParams} from "./urlparams";


export default class PaidChannel {

    public static is(params: ParsedUrlParams) {
        const data = ClickData.parse(params);
        if (data.id.length) {
            if (DisplayChannel.is(params)) {
                // Display, not Paid Search
                return false;
            }
            return true;
        }
        return false;
    }

}
